import { create } from "zustand";

interface CartSheetStore {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
}

/**
 * The header cart. Opened from the header's cart button and after adding a
 * product on its page, so the customer sees it land.
 */
export const useCartSheet = create<CartSheetStore>()((set) => ({
  isOpen: false,
  setOpen: (isOpen) => set({ isOpen }),
}));
